import { theme } from './theme';
import type { Theme, ThemeColors } from './types';

export const useCustomTheme = (colors: ThemeColors): Theme => ({
  ...theme,
  colors,
});
